import { styled, Typography } from "@mui/material";

export const ReportCell = styled(Typography)(({ theme }) => ({
  ...theme.typography.regularText,
  display: "flex",
  alignItems: "center",
  minHeight: 40,
}));
